Ember.TextField.reopen(Em.I18n.TranslateableAttributes)